export const SUGGESTED_COLORS_UPDATE = 'SUGGESTED_COLORS_UPDATE';
export const USED_COLOR_COMBOS_UPDATE = 'USED_COLOR_COMBOS_UPDATE';
